/**
 * Account information PNZ-API-CentreLib
 *
 * This file was automatically generated by APIMATIC v3.0 ( https://www.apimatic.io ).
 */

import { lazy, object, Schema } from '../schema';
import { Data9, data9Schema } from './data9';
import { Links, linksSchema } from './links';
import { Meta, metaSchema } from './meta';

export interface AC108Retrievebulkstandingorders {
  data: Data9;
  links: Links;
  meta: Meta;
}

export const aC108RetrievebulkstandingordersSchema: Schema<AC108Retrievebulkstandingorders> = object(
  {
    data: ['Data', lazy(() => data9Schema)],
    links: ['Links', lazy(() => linksSchema)],
    meta: ['Meta', lazy(() => metaSchema)],
  }
);
